/* src/app/modules/user/user-tabs.component.scss */
/*# sourceMappingURL=user-tabs.component.css.map */
